exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.job-info .price-per-hour[data-v-9b1e9f7c] {\n  font-weight: bold;\n  font-size: 18px;\n  color: #4c5669;\n  position: initial;\n  margin-right: 5px;\n}\n.dropdown-menu[data-v-9b1e9f7c] {\n  max-height: 340px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9b1e9f7c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/jobs/JobInfo.vue
// module id = xcc6
// module chunks = 0